export const PaymentTypes = {
  CREATE_PAYMENT_INTENT: "PAYMENT::CREATE_PAYMENT_INTENT",
  CREATE_PAYMENT_INTENT_SUCCESS: "PAYMENT::CREATE_PAYMENT_INTENT_SUCCESS",
  UPDATE_PAYMENT_INTENT: "PAYMENT::UPDATE_PAYMENT_INTENT",
  UPDATE_PAYMENT_INTENT_SUCCESS: "PAYMENT::UPDATE_PAYMENT_INTENT_SUCCESS",
  UPDATE_PAYMENT_AMOUNT: "PAYMENT::UPDATE_PAYMENT_AMOUNT",
  CLEAR_PAYMENT_INTENT: "PAYMENT::CLEAR_PAYMENT_INTENT"
};
